import { render, staticRenderFns } from "./activty-groups-config.vue?vue&type=template&id=1c6fd01f"
import script from "./activty-groups-config.vue?vue&type=script&lang=js"
export * from "./activty-groups-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports